import { useQuery } from "@tanstack/react-query";
import { http } from "../../../../../../services/HttpService";
import { QUERY_KEYS, HTTP_ENDPOINTS } from "../../../../../../consts/api";

export const useEgiftSalesV2 = (params, options = {}) => {
  return useQuery(
    [QUERY_KEYS.egiftSalesV2, params],
    async () => {
      const res = await http.get(HTTP_ENDPOINTS.getEgiftSalesV2(), {
        params,
      });

      const composeResponse = {
        clinics: Object.values(res.data.data.filters.clinics || {}),
        clinicEgiftSales: res.data.data.report.clinic_report,
        providerEgiftSales: res.data.data.report.provider_report,
      };
      return composeResponse;
    },
    options,
  );
};
